exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.expandable-section{border-bottom:2px solid #9b9b9b}.task-inventory{margin-left:38px;width:calc(100% - 38px)}.task-inventory__add-button{width:calc(100% - 24px);height:32px;font-family:Open Sans,sans-serif;color:#fff;font-size:14px;font-weight:600;background-color:#184e78;border-radius:4px;margin-bottom:16px}.task-inventory__item{border-top:1px solid #184e78;display:flex;justify-content:space-between;height:55px;position:relative}.task-inventory__item .item-id-name{height:100%;width:calc(100% - 60px)}.task-inventory__item .item-id-name__id,.task-inventory__item .item-id-name__name{font-family:Open Sans,sans-serif;margin-bottom:0;line-height:16px}.task-inventory__item .item-id-name__id{margin-top:10px;font-weight:600;font-size:14px;color:#2c2c2c;text-overflow:ellipsis;white-space:nowrap;width:100%;overflow:hidden}.task-inventory__item .item-id-name__name{margin-top:0;font-size:14px;color:#9b9b9b;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.task-inventory__item:last-child{border-bottom:1px solid #184e78;margin-bottom:16px}.task-inventory__item .offline-indicator{position:absolute;top:20px;right:48px}.task-inventory__arrow{height:16px;align-self:center;margin-right:24px}.task-inventory__trash-can{cursor:pointer;margin-right:20px}.task-inventory__no-items{margin-top:0;font-family:Open Sans,sans-serif;line-height:16px;font-size:12px;color:#2c2c2c}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/TaskCRUD/TaskInventory/TaskInventory.scss
// module id = 1652
// module chunks = 0